import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { TextField } from '@material-ui/core';
import notice from 'src/common/components/Notice';
import { useStyles } from './styles';
import { usersAPI } from 'src/api/modules/users';
import { actions as passwordRequest } from '../../../redux/ducks/passwordRequest';
import { actions as changePassword } from '../../../redux/ducks/changePassword';
import { Button } from '@material-ui/core';

function PasswordRequest() {
	const classes = useStyles();
	const dispatch = useDispatch();
	const [user, setuser] = useState('');
	const isDev = process.env.REACT_APP_ENVIRONMENT === 'DEV';

	const handleChange = (e) => {
		const { name, value } = e.target;
		setuser({ ...user, [name]: value });
	};

	const handleSubmit = (e) => {
		if (user.usuario === undefined) return notice('Ingresa tu usuario', 'info');
		let typeUser = user.usuario.substr(0, 2);

		if (typeUser !== 'IS')
			return notice(
				'El usuario no cumple con los requisitos para solicitar cambio de contraseña, solo usuarios externos.'
			);

		usersAPI
			.postRecoverPassword(user.usuario)
			.then((res) => {
				if (res.codigo === 'SAOC-400' || res.codigo === 'SAOC: 500') {
					notice(JSON.parse(JSON.stringify(res.mensaje)));
					dispatch(changePassword.SetChangePass(0));
					dispatch(passwordRequest.SetPassRequest(true));

					return false;
				} else {
					notice(
						'Se ha enviado una contraseña temporal al correo electronico registrado del usuario ' +
							user.usuario,
						'success'
					);

					dispatch(passwordRequest.SetPassRequest(false));
					dispatch(changePassword.SetChangePass(false));
				}
			})
			.catch((e) => {
				if (isDev) {
					if (
						e.response === undefined ||
						e.response.data.mensaje === undefined
					) {
						notice(
							'Ha ocurrido un error con su petición, contacte a un administrador.'
						);
					} else {
						notice(JSON.parse(JSON.stringify(e.response.data.mensaje)));
					}

					dispatch(changePassword.SetChangePass(0));
					dispatch(passwordRequest.SetPassRequest(true));

					return false;
				} else
					notice(
						'Ha ocurrido un error con su petición, contacte a un administrador.'
					);
			});
	};

	const onCancel = () => {

		dispatch(passwordRequest.SetPassRequest(false));
		dispatch(changePassword.SetChangePass(false));
	};

	return (
		<div
			className={`login-form login-signin ${classes.containerForm}`}
			id="login_password_Request"
		>
			<div className="mb-10 mb-lg-10">
				<h3 className="font-size-h2 text-danger text-center"></h3>
			</div>
			{/* end::Head */}

			{/*begin::Form*/}
			<form>
				<div className={classes.containerForm}>
					<p class="ml-lg-1 mb-3">
						Ingrese su Usuario para Solicitar un Nuevo Acceso
					</p>
					<TextField
						id="userPR"
						name="usuario"
						className={classes.textField}
						label="Usuario"
						variant="outlined"
						onChange={handleChange}
					/>

					<div className="text-center">
						<button
							className={`btn btn-light  font-weight-bold px-9 py-4 my-3 rounded-lg `}
							onClick={onCancel}
						>
							<span>Cancelar</span>
						</button>
						<Button
							className={`btn btn-danger font-weight-bold px-9 py-4 my-3 rounded-lg  ml-lg-10 `}
							onClick={handleSubmit}
							variant="text"
						>
							<p class="text-capitalize">Solicitar cambio de contraseña</p>
						</Button>
					</div>
				</div>
			</form>
			{/*end::Form*/}
		</div>
	);
}

export default PasswordRequest;
